export default "__VITE_ASSET__8e95cf75__"